import * as Yup from "yup";
import { StringValidation, DropdownValidation } from "./PlanSchema";

export const GlobalSettingsSchema = Yup.object().shape({
  name: StringValidation.label("Name"),
  min_score: StringValidation.label("Min Score"),
  max_score: StringValidation.label("Max Score"),
  target_score: StringValidation.label("Target Score"),
  period_id: DropdownValidation.label("Period"),
});
